import { FC } from "react";
import { Skeleton } from "@mui/material";
import "@xyflow/react/dist/style.css";
import { ReactFlowProvider } from "@xyflow/react";
import AreaMembersDialog from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Components/AreaMembersDialog";
import OrgchartTree from "./OrgchartTree";
import FilterBar from "./FilterBar";
import useOrgchartAreasStore from "./store";
import { useAreasOrgchartData } from "./api";

interface IAreasOrgchartDataProvider {
  companyId: string;
  structureId: string;
}

const AreasOrgchartDataProvider: FC<IAreasOrgchartDataProvider> = ({
  companyId,
  structureId,
}) => {
  const { isLoading } = useAreasOrgchartData({ companyId, structureId });
  const { areaDataForDialog } = useOrgchartAreasStore();

  return (
    <ReactFlowProvider>
      <FilterBar companyId={companyId} />
      {isLoading ? (
        <Skeleton variant="rectangular" height={600} />
      ) : (
        <>
          {areaDataForDialog.name !== "" && (
            <AreaMembersDialog
              structureId={structureId}
              companyId={companyId}
            />
          )}
          <OrgchartTree />
        </>
      )}
    </ReactFlowProvider>
  );
};

export default AreasOrgchartDataProvider;
